import React from 'react';
import '../../App.css';
import TechContent from '../TechContent';

function TechGenics() {
    return (
      <>
          <TechContent />
      </>
    )
  }

export default TechGenics;